import { useQuery } from '@tanstack/react-query';
import resolveApiBase from '../../tradingCockpit/apiBase';

const API_BASE = resolveApiBase();
const API_KEY = process.env.REACT_APP_API_KEY || '';
const POLL_MS = 5000;
const PAGE_SIZE = 25;

const resolveUrl = (path) => {
    if (!API_BASE) {
        return path;
    }
    const normalisedBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    return `${normalisedBase}${path.startsWith('/') ? path : `/${path}`}`;
};

const buildHeaders = () => {
    const headers = { Accept: 'application/json' };
    if (API_KEY) {
        headers['x-api-key'] = API_KEY;
    }
    return headers;
};

async function fetchTelemetryFeed({ strategyId, limit, offset }) {
    const params = new URLSearchParams();
    if (strategyId) {
        params.set('strategyId', strategyId);
    }
    if (limit != null) {
        params.set('limit', String(limit));
    }
    if (offset != null) {
        params.set('offset', String(offset));
    }

    const query = params.toString();
    const path = query ? `/api/insights/telemetry/feed?${query}` : '/api/insights/telemetry/feed';
    const response = await fetch(resolveUrl(path), {
        headers: buildHeaders(),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`${response.status}: ${text}`);
    }
    return response.json();
}

export function useMergedTelemetryFeed({ strategyId = null, pageSize = PAGE_SIZE } = {}) {
    return useQuery({
        queryKey: ['insights', 'telemetry', 'feed', strategyId, pageSize],
        queryFn: () =>
            fetchTelemetryFeed({
                strategyId,
                limit: pageSize,
                offset: 0,
            }),
        staleTime: 3000,
        refetchInterval: POLL_MS,
    });
}

export { PAGE_SIZE };
